// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"I1-z","upvote":"J1-z","downvote":"K1-z","numVotes":"L1-z","votesDescription":"M1-z","report":"N1-z","voted":"O1-z","answerVoteBox":"P1-z","justReported":"Q1-z"};